import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// Design system first (role tokens + base reset + themes + the canonical
// component classes), then this app's own stylesheet on top.
import '@cca/ui/styles';
import '@cca/ui/components';
import './styles/ballot.css';
// The results sheet reads ballot.css's own tokens (the 16px reading floor, the
// portal's --color-structural) and reuses several of its rules, so it loads
// after it, never before.
import './styles/result.css';
// The register reads BOTH of the above — ballot.css's 16px floor and 48px touch
// token, and result.css's subheading and provenance rules — so it loads last.
import './styles/register.css';
// The scrutineer operator panel reads ballot.css's floor + touch tokens and reuses
// result.css's sheet (it embeds <ResultPage>), so it loads after both.
import './styles/scrutineer.css';
// The operator setup hub reads ballot.css's floor + touch tokens and reuses
// result.css's provenance/mono rules (the digest disclosures), so it loads after
// both.
import './styles/setup.css';
// Print last of all: it only ever SUBTRACTS from the screen stylesheets and
// reveals their print-only blocks (the provenance fact copy, the countersign
// lines), so it must win every specificity tie — and losing it costs the paper
// copy, never the screen.
import './styles/print.css';

// NO initTelemetry() here, and that is deliberate rather than forgotten: the
// client telemetry channel POSTs to `/api/telemetry`, and this app has no worker
// and no Pages Function to receive it. Wiring it now would produce a page that
// fails a request on every error it is trying to report. It lands in the change
// that gives CCA-decides a server — the same change that adds this package to
// @cca/conformance's WEB_APPS list, where OBS-6 then requires it (see README).

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
